var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", {
      staticClass: "h1 main",
      domProps: { innerHTML: _vm._s(_vm.topText) },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "position-relative" },
      [
        _vm._l(_vm.changingTexts, function (text, i) {
          return _c("h2", {
            key: "changing-" + i,
            staticClass: "h1 black animate-h1",
            class: [i === _vm.activeIndex ? "active" : "", "animate-h1-" + i],
            domProps: { innerHTML: _vm._s(text) },
          })
        }),
        _vm._v(" "),
        _c("h2", {
          staticClass: "h1 height-placeholder",
          domProps: { innerHTML: _vm._s(_vm.placeholderText) },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }